import { z } from 'zod';
/**
 * Two kinds of thing in one list. The first three are questions — somebody is
 * waiting on the answer — and the rest are statements. Adding a kind means a
 * migration, because the database holds this as an enum: deliberate, so a
 * typo cannot invent a notification nobody's inbox knows how to draw.
 */
export const notificationKindSchema = z.enum([
    'shared_meal',
    'shared_activity',
    'shared_event',
    'plan_ready',
    'plan_failed',
    'sync_failed',
    'share_granted',
    'share_revoked',
    'household',
]);
/** The kinds that ask rather than tell. */
export const ACTIONABLE_KINDS = ['shared_meal', 'shared_activity', 'shared_event'];
export function isActionableKind(kind) {
    return ACTIONABLE_KINDS.includes(kind);
}
export const notificationDecisionSchema = z.enum(['pending', 'accepted', 'rejected']);
export const notificationSchema = z.object({
    id: z.string().uuid(),
    kind: notificationKindSchema,
    title: z.string(),
    body: z.string().nullable(),
    /** Who caused it, where a person did. */
    actorMemberId: z.string().uuid().nullable(),
    actorName: z.string().nullable(),
    subjectKind: z.string().nullable(),
    subjectId: z.string().uuid().nullable(),
    payload: z.record(z.unknown()),
    /** Null on a statement. A question is 'pending' until it is answered. */
    decision: notificationDecisionSchema.nullable(),
    decidedAt: z.string().datetime().nullable(),
    readAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
export const notificationListQuerySchema = z.object({
    /** Unanswered questions first is the default; `all` is the full history. */
    filter: z.enum(['all', 'unread', 'pending']).default('all'),
    limit: z.coerce.number().int().min(1).max(100).default(30),
});
export const notificationCountSchema = z.object({
    /** Drives the badge. */
    unread: z.number().int().min(0),
    /** Questions still waiting on this person. */
    pending: z.number().int().min(0),
});
export const notificationDecisionRequestSchema = z.object({
    decision: z.enum(['accepted', 'rejected']),
    /** "Yes, but I'll have half": a revised portion, in servings, when accepting a meal. */
    servings: z.number().positive().max(20).nullish(),
});
//# sourceMappingURL=notification.js.map